/* eslint-disable no-undef */
// userSaga.js
import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { CREATE_APPOINTMENT, PAYMENT_CONFIRMED, REQUEST_PAYMENT } from './Constants';
import { createAppointmentRequestError, createAppointmentRequestSuccess, paymentConfirmedRequest, paymentConfirmedRequestError, paymentConfirmedRequestSuccess, paymentRequestError } from './Actions';
import { jwtDecode } from 'jwt-decode';
import { selectAppointmentSuccessData } from './Selectors';
// import { Modal } from 'antd';


function* createAppointment(action) {

    try {

        const schedule = action.payload;
        const user = jwtDecode(sessionStorage.jwt);
        const patId = action.patientId;


        let url = `${process.env.REACT_APP_API_BASE_URL}/appointments`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        let data = {
            organisationsId: schedule.organisation.id,
            appUrl: '',
            isPaymentDone: false,
            status: 'created',
            isMailSent: false,
            patientsId: patId,
            doctorsId: schedule.doctorsId,
            schedulesId: schedule.id,
            createdById: user.userId,
            createdByTypeId: 5,
            date: schedule.date,
            time: schedule.time,
            parentId: sessionStorage.PATIENT_ID,
            createdByOrgId: 1,
            consultationtypeId: schedule.consultationTypeId,
            platform: 'Quikdr Webapp',
            consultingOrgId: schedule.organisationsId,
        };


        const response1 = yield call(axios.post, url, data, { headers });

        // // Check if the response is successful
        if (response1.status === 200 || response1.status === 201) {

            url = `${process.env.REACT_APP_API_BASE_URL}/schedules/${schedule.id}`;

            let data = {
                isVacant: false,
            };

            const response2 = yield call(axios.patch, url, data, { headers });

            if (response2.status === 200 || response2.status === 201) {
                yield put(createAppointmentRequestSuccess(response1.data));
            } else {
                yield put(createAppointmentRequestError('An error occurred.'));
            }

            // Dispatch the success action with data and message      
        } else {
            // Dispatch the failure action with the response message
            // yield put(timeSlotRequestError('An error occurred.'));
            yield put(createAppointmentRequestError('An error occurred.'));
        }
    } catch (error) {

        yield put(createAppointmentRequestError('An error occurred.'));
        // throw error;
        // yield put(fetchUserFailure(error));
    }
}

function* requestPayment(action) {
    try {

        let amount = Number((action.payload) * 100).toFixed(0);

        let patientDetails;
        let url = `${process.env.REACT_APP_API_BASE_URL}/patients/${sessionStorage.PATIENT_ID}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response1 = yield call(axios.get, url, { headers });

        if (response1.status === 200 || response1.status === 201) {
            patientDetails = response1.data;
            const date = new Date();
            date.setTime(date.getTime() + 60 * 60 * 1000);

            url = `${process.env.REACT_APP_API_BASE_URL}/razorpay`;
            let data = {
                type: 'link',
                amount, // eslint-disable-line
                'customer[email]': patientDetails.user ? patientDetails.user.email : patientDetails.primaryEmail,
                currency: 'INR',
                description: 'QuikDr Appointments',
                expire_by: Math.floor(new Date(date).getTime() / 1000),
                'customer[name]': `${patientDetails.firstName} ${patientDetails.lastName}`,
                'customer[contact]': patientDetails.primaryContact,
            };

            const response2 = yield call(axios.post, url, data, { headers });
            if (response2.status === 200 || response2.status === 201) {
                yield put(paymentConfirmedRequest(response2.data[0], action.scheduleData));

            } else {
                yield put(paymentRequestError('An error occurred.'));
            }


        }
        else {
            yield put(paymentRequestError('An error occurred.'));
        }


    } catch (error) {
        yield put(paymentRequestError('An error occurred.'));
    }
}

function* paymentConfirmed(action) {
    try {
        const appointData = yield select(selectAppointmentSuccessData);
                
        let razorpay = action.payload;
        let schedule = action.scheduleData;
        let couponFlag = false;
        let couponId = null;
        let discountedAmount = 0;
        let item = schedule;

        const quikDrFee =
            item.organisation.quikdrFeeType === 'Variable'
                ? (item.orgfee.amount / 100) * item.organisation.quikdrFeeAmount
                : item.organisation.quikdrFeeAmount;
        const amount =
            item.orgfee.amount +
            quikDrFee +
            (item.orgfee.amount + quikDrFee) * (item.organisation.taxPercent / 100);
        let bankCharge = (amount / 100) * item.organisation.bankChargePercent;
        bankCharge += bankCharge * (item.organisation.taxPercent / 100);
        const tax = ((quikDrFee + item.orgfee.amount) / 100) * item.organisation.taxPercent;
        // const TotalAmount = Number((amount + bankCharge).toFixed(2));

        let quikdrFees;
        let consultationfee;
        let QuikDrTaxs;
        let totals;
        let FinalAmount;
        let BankCharges;
        // let razorAmounts;

        consultationfee = Number(item.orgfee.amount);
        if (item.organisation.quikdrFeeType === 'Fixed') {
            quikdrFees = Number(item.organisation.quikdrFeeAmount);
        } else if (item.organisation.quikdrFeeType === 'Variable') {
            quikdrFees = Number(consultationfee * (item.organisation.quikdrFeeAmount / 100));
        }
        QuikDrTaxs = Number(quikdrFees * (item.organisation.taxPercent / 100));

        totals = Number(consultationfee + quikdrFees + QuikDrTaxs);

        BankCharges = totals * (Number(item.organisation.bankChargePercent) / 100);

        FinalAmount = Number(totals + BankCharges).toFixed(2);

        const url = `${process.env.REACT_APP_API_BASE_URL}/payments`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const data = {
            paymentType: 'razorpay',
            bankCharge, // eslint-disable-line
            quickDrFee: quikDrFee,
            amount: FinalAmount,
            tax, // eslint-disable-line
            gatewayUrl: razorpay.short_url,
            patientsId: sessionStorage.PATIENT_ID,
            appointmentsId: appointData.id,
            doctorsId: item.doctorsId,
            organisationsId: item.organisation.id,
            consultationAmount: item.orgfee.amount,
            createdByOrgId: 140,
            couponId,
            isCouponApplied: couponFlag,
            dicountedPrice: discountedAmount,
        };

        const response = yield call(axios.post, url, data, { headers });
        

        if (response.status === 200 || response.status === 201) {
            const url2 = `${process.env.REACT_APP_API_BASE_URL}/razorpayupdater/${razorpay.id}`;

            const response2 = yield call(axios.get, url2, { headers });

            if (response2.status === 200 || response2.status === 201) {                
                yield put(paymentConfirmedRequestSuccess(razorpay));
            } else {
                yield put(paymentConfirmedRequestError('An error occurred.'));
            }
        } else {
            yield put(paymentConfirmedRequestError('An error occurred.'));
        }
    }
    catch {
        yield put(paymentConfirmedRequestError('An error occurred.'));

    }
}

// Watcher Saga
export function* watchFetchSelectLocation() {
    yield takeEvery(CREATE_APPOINTMENT, createAppointment);
    yield takeEvery(REQUEST_PAYMENT, requestPayment);
    yield takeEvery(PAYMENT_CONFIRMED, paymentConfirmed);

}
